module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top-seciton"
    }
  }, [_vm._v("\n    hello top seciton         \n    "), _c('div', {
    staticClass: "test"
  }, [_vm._v("\n       test green \n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-c7780f16"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/TopSection.vue
// module id = 33
// module chunks = 0